import { queryBatteryPower, queryBatteryPage,addBattery,updateBattery,deleteBatteryById,batteryAppropriate,batteryBinding,uploadBattery,queryBatteryStatusPage,queryBatteryInfo,queryBatteryChargeInfo } from "../../api/config/modules/BatteryFile";

const state = {
    queryBatteryPage: {},
    addBattery: {},
    updateBattery: {},
    deleteBatteryById: {},
    batteryAppropriate: {},
    batteryBinding: {},
    uploadBattery: {},
    queryBatteryStatusPage: {},
    queryBatteryInfo: {},
    queryBatteryChargeInfo: {},
    queryBatteryPower: {}
};

const mutations = {
  SET_QUERYBATTERYPAGE: (state, queryBatteryPage) => {
    state.queryBatteryPage = queryBatteryPage;
  },
  SET_INSERTBATTERY: (state, addBattery) => {
    state.addBattery = addBattery;
  },
  SET_UPDATEBATTERY: (state, updateBattery) => {
    state.updateBattery = updateBattery;
  },
  SET_DELETEBATTERYBYID: (state, deleteBatteryById) => {
    state.deleteBatteryById = deleteBatteryById;
  },
  SET_BATTERYAPPROPRIATE: (state, batteryAppropriate) => {
    state.batteryAppropriate = batteryAppropriate;
  },
  SET_BATTERYBINDING: (state, batteryBinding) => {
    state.batteryBinding = batteryBinding;
  },
  SET_UPLOADBATTERY: (state, uploadBattery) => {
    state.uploadBattery = uploadBattery;
  },
  SET_QUERYBATTERYSTATUSPAGE: (state, queryBatteryStatusPage) => {
    state.queryBatteryStatusPage = queryBatteryStatusPage;
  },
  SET_QUERYBATTERYINFO: (state, queryBatteryInfo) => {
    state.queryBatteryInfo = queryBatteryInfo;
  },
  SET_QUERYBATTERYCHARGEINFO: (state, queryBatteryChargeInfo) => {
    state.queryBatteryChargeInfo = queryBatteryChargeInfo;
  },
  SET_QUERYBATTERYPOWER: (state, queryBatteryPower) => {
    state.queryBatteryPower = queryBatteryPower;
  },
};

const actions = {
  GET_QUERYBATTERYPAGE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        queryBatteryPage(data)
        .then((res) => {
          commit("SET_QUERYBATTERYPAGE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_INSERTBATTERY: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        addBattery(data)
        .then((res) => {
          commit("SET_INSERTBATTERY", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_UPDATEBATTERY: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        updateBattery(data)
        .then((res) => {
          commit("SET_UPDATEBATTERY", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_DELETEBATTERYBYID: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        deleteBatteryById(data)
        .then((res) => {
          commit("SET_DELETEBATTERYBYID", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_BATTERYAPPROPRIATE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        batteryAppropriate(data)
        .then((res) => {
          commit("SET_BATTERYAPPROPRIATE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_BATTERYBINDING: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        batteryBinding(data)
        .then((res) => {
          commit("SET_BATTERYBINDING", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_UPLOADBATTERY: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        uploadBattery(data)
        .then((res) => {
          commit("SET_UPLOADBATTERY", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_QUERYBATTERYSTATUSPAGE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        queryBatteryStatusPage(data)
        .then((res) => {
          commit("SET_QUERYBATTERYSTATUSPAGE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_QUERYBATTERYINFO: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        queryBatteryInfo(data)
        .then((res) => {
          commit("SET_QUERYBATTERYINFO", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_QUERYBATTERYCHARGEINFO: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        queryBatteryChargeInfo(data)
        .then((res) => {
          commit("SET_QUERYBATTERYCHARGEINFO", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_QUERYBATTERYPOWER: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      queryBatteryPower(data)
        .then((res) => {
          commit("SET_QUERYBATTERYPOWER", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
